import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { eva_constants } from '../eva_constants';

@Injectable()
export class ThemeService {
  private activeTheme = new BehaviorSubject(eva_constants.EVA_THEME);

  constructor() {}

  public getActiveTheme() {
    return this.activeTheme.asObservable();
  }

  public setActiveTheme(name: string) {
    if (!name) return;

    if (this.activeTheme && this.activeTheme.value !== name) {
      this.activeTheme.next(name);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/theme.service.ts